import React, { type ReactElement, type ReactNode } from 'react';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { Text, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

const MessageContainer = ({ icon, children }: { icon: ReactElement; children: ReactNode[] }) => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.150" xcss={stackStyles} alignInline="center">
			{icon}
			<Text color="color.text">{formatMessage(messages.noOptionsPrimaryMessage)}</Text>
			<Text color="color.text.subtle" size="small">
				{formatMessage(messages.noOptionsSecondaryMessage)}
			</Text>

			{children}
		</Stack>
	);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */
const NoOptionsMessage = ({ children }: { children?: ReactNode }) => {
	return (
		<MessageContainer
			icon={<ErrorIcon label="" color={token('color.icon')} LEGACY_primaryColor="currentColor" />}
		>
			{children}
			<FireUiAnalytics actionSubject="emptyState" action="viewed" actionSubjectId="columnPicker" />
		</MessageContainer>
	);
};

export default NoOptionsMessage;

const stackStyles = xcss({
	paddingBlock: 'space.150',
	paddingInline: 'space.100',
	// this is for the children additional help text/content
	color: 'color.text.subtlest',
});
